module.exports = __webpack_public_path__ + "img/a-ziyuan10.d5994d3d.png";